import {OPENQUERY} from './OpenQueryTypes'
const initialState = {
    openQuery: {state: false,name: ''}
}

const setOpenQuery = (state = initialState, action) => {
    
    switch (action.type) {
        case OPENQUERY:
            
            return {
                openQuery: action.load
            }
    
        default:
          return state
    }

}


export default setOpenQuery;